<span class="fs-14px text-color-gray-9 sp-mr-10 desktop">{{ "reflections_cadence_compare_button" | localize }}</span>
<span class="fs-14px text-color-gray-9 sp-mr-10 mobile">{{ "compare" | localize }}</span>
<ui-toggle [ngModel]="isComparing" [attr.aria-label]="'compare_with_previous_week' | localize" [attr.data-test-id]="'check-in-compare-btn'" (ngModelChange)="toggleStatus()"></ui-toggle>
